























import { Component, Vue, Prop, Emit } from 'vue-property-decorator'
import { RegisterShop } from '@/api'
import { ElForm } from 'element-ui/types/form'
import { VImageUpload } from '@/components/upload'

@Component({
  components: {
    VImageUpload
  }
})
export default class EditBaseShopDialog extends Vue {
  @Prop({ type: Boolean, default: false }) private appendToBody!: boolean

  @Emit('close')
  private close() {
    const f = this.$refs.form as ElForm
    f.resetFields()
    this.data = {
      name: undefined,
      account: undefined,
      pwd: undefined,
      confirmPwd: undefined
    }
    this.show = false
  }
  private data: any = {
    name: undefined,
    account: undefined,
    pwd: undefined,
    confirmPwd: undefined
  }
  private show = false
  private buttonLoading = false
  private isEdit = false

  public async open() {
    this.show = true
  }

  // 验证确认密码的函数
    private validateConfirmPassword = (rule: any, value: any, callback: any) => {
      if (value !== this.data.pwd) {
        callback(new Error('两次输入的密码不一致'));
      } else {
        callback();
      }
    };

  private requiredRule = {
    required: true,
    message: '不能为空',
    trigger: 'blur'
  }
  private rules = {
    name: [this.requiredRule],
    account: [this.requiredRule],
    pwd: [this.requiredRule],
    confirmPwd: [this.requiredRule,{ validator: this.validateConfirmPassword, trigger: 'blur' }]
  }

  public async save() {
    this.buttonLoading = true
    try {
      const form = this.$refs.form as ElForm
      form.validate(async (valid: boolean) => {
        if (valid) {
          let result = {}
          RegisterShop(this.data).then((RegisterShop) => {
            console.log(result)
            if (result) {
              this.close()
            }
          })
        } else {
          this.$message.error('表单存在错误，不能保存')
          return false
        }
      })
    } finally {
      this.buttonLoading = false
    }
  }
}
